import client from './client';

export const adminAPI = {
  // Get all admins with pagination
  getAdmins(params = {}) {
    return client.get('/admins', { params });
  },

  // Get admin by ID
  getAdminById(id) {
    return client.get(`/admins/${id}`);
  },

  // Create new admin
  createAdmin(adminData) {
    return client.post('/admins', adminData);
  },

  // Update admin
  updateAdmin(id, adminData) {
    return client.put(`/admins/${id}`, adminData);
  },

  // Delete admin
  deleteAdmin(id) {
    return client.delete(`/admins/${id}`);
  }
};

export default adminAPI;
